import { HttpClient, HttpEventType } from '@angular/common/http';

import { Injectable } from '@angular/core';
import { MainService } from './main.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { LedgerService } from './ledger.service';
import { ContraService } from './contra.service';

import {session} from '../../../environments/environment.session'
import Swal from 'sweetalert2';
import { BpService } from './bp.service';
import { BillService } from './bill.service';
import { BudgetEffectService } from './budget-effect.service';
import { RuleProcessingNewService } from './rule-processing-new.service';
import { EventGroupService } from './event-group.service';


@Injectable({
  providedIn: 'root'
})
export class ProcessDocumentService {

  httpUrl;
  erpUser;
  b_acct_id;
  current_date: any
  systemDate: any
  constructor(
    // private http: HttpClient,
    private spinner: NgxSpinnerService,
    private main: MainService, private ledgerService: LedgerService,
    // private contraService: ContraService,
    // private BPS: BpService, private billService: BillService,

    private budgetEffectService: BudgetEffectService,
    private ruleProcessingNewService: RuleProcessingNewService,
    private eventGroupService: EventGroupService

  ) {
    this.httpUrl = this.main.httpUrl + "/account/event";
    this.erpUser = JSON.parse(atob(session.erpUser));
    this.b_acct_id = this.erpUser.b_acct_id;
    this.current_date = new Date().toISOString().split('T')[0];
  }

  // allChartOfAccount = []
  ChartOfAccountObj: any = {}
  async getChartOfAccount() {
    this.spinner.show();
    let obj:any = new Object();
    obj["b_acct_id"] = this.b_acct_id;
    let resp = await this.ledgerService.getchartofaccount(JSON.stringify(obj));
    if (resp["error"] == false) {
      const allChartOfAccount = resp.data;
      allChartOfAccount.map((x:any) => {
        this.ChartOfAccountObj[x['leaf_code']] = x['leaf_value']
      })
      this.spinner.hide();
    } else {
      this.spinner.hide();
      Swal.fire("ERROR", "Error while getting  all chart of account info", "error");
    }
  }

  fin_year:any;
  async FinYear() {
    let obj:any = new Object();
    obj["b_acct_id"] = this.b_acct_id;
    let resp = await this.ledgerService.getActiveFinYear(JSON.stringify(obj));
    if (resp["error"] == false) {
      if (resp.data.length == 0) {
        Swal.fire("WARNING", "Active Financial Year Not set!", "warning");
      } else {
        this.fin_year = resp.data[0].fin_year;
      }
    } else {
      Swal.fire("ERROR", "Error while getting active  fin year", "error");
    }
  }
  /************************************Posting of manual journla start ***************************************************** */



  async postManualJournal(element:any) {

    await this.getChartOfAccount();
    await this.FinYear();


    this.spinner.show();
    const d = new Date();
    let month = d.getMonth();
    let data = [];

    let fetcObj:any = {}
    fetcObj['b_acct_id'] = this.b_acct_id;
    fetcObj['id'] = element.doc_local_no;
    let manual_jrnl = await this.ledgerService.getManulaJournalById(JSON.stringify(fetcObj));

    let bud_obj = await this.budgetEffectService.getBudgetObjForManualJournal(manual_jrnl["data"][0], this.b_acct_id);
    if (bud_obj['error'] === true) {
      this.spinner.hide();
      Swal.fire("Error", bud_obj['data'], 'error');
      return false;
    }

    if (manual_jrnl['error'] == false) {
      let all_account_lines = JSON.parse(manual_jrnl['data'][0]['data_lines']);
      for (let i = 0; i < all_account_lines.length; i++) {
        if (all_account_lines[i]["type"] == "credit") {
          let ob:any = new Object();

          ob["arr_id"] = manual_jrnl['data'][0]["jrnl_id"];
          ob["ar_cntr_ip_id"] =
            all_account_lines[i]["data"]["ar_cntr_ip_id"];
          ob["ar_cntr_ip_name"] =
            all_account_lines[i]["data"]["ar_cntr_ip_name"];
          ob["event_id"] = manual_jrnl['data'][0]['id']
          ob["ld_prj_cd"] = all_account_lines[i]['data']["proj_cd"];
          ob["ld_act_cd"] = all_account_lines[i]['data']["act_cd"];
          ob["ld_pd_cd"] = all_account_lines[i]['data']["prod_cd"];
          ob["ld_bugt_cd"] = all_account_lines[i]['data']["bud_cd"];
          ob["txn_amt"] = all_account_lines[i]["data"]["txn_amt"]

          ob["chart_of_account"] =
            all_account_lines[i]["data"]["chart_of_account"];
          ob["db_cd_ind"] =
            all_account_lines[i]["data"]["db_cd_ind"];
          ob["ar_actvty_tcd"] = "MANUAL_JRNL";
          ob["jrnl_dtl_ln_id"] =
            all_account_lines[i]["data"]["jrnl_dtl_ln_id"];
          ob["jrnl_desc"] = " By " + this.ChartOfAccountObj[all_account_lines[i]["data"]["chart_of_account"]];
          ob["org_unit_cd"] = this.b_acct_id;
          ob["tgt_curr_cd"] = "INR";
          ob["jrnl_ln_id"] = "_" + i;
          ob["fin_year"] = this.fin_year;
          ob["ev_cts"] = this.current_date;
          ob["ld_fm"] = month + 1;
          ob["acct_dt"] = all_account_lines[i]['data']["acct_dt"];

          ob["ledger_type"] = "ACT";
          ob["prep_id"] = all_account_lines[i]["data"]["prep_id"];
          ob["appr_id"] = this.erpUser.user_id;
          ob["ar_actvty_lcl_num"] = manual_jrnl['data'][0]['id']
          ob["ar_src_cd"] = "ACCOUNT";
          ob["cp_bnk_acct_id"] = all_account_lines[i]["data"]["cp_bnk_acct_id"]
          ob["event_code"] = all_account_lines[i]["data"]["event_code"];
          ob["ld_jrnl_ref_num"] = "ACCOUNT-MANUAL_JOURNAL-" + manual_jrnl['data'][0]["jrnl_id"];
          ob["ld_jrnl_lfcycl_st_cd"] = "POSTED";
          ob["ld_jrnl_unpost_seq_num"] = 0;
          ob["ld_acct_per"] = 0;
          ob["ld_cat_cd"] = "FIN";
          ob["ld_jrnl_rvrsl_tcd"] = manual_jrnl['data'][0]['preparer_comment'];
          ob["ld_tgt_cur_tcd"] = "FN";
          ob["ld_jrnl_entry_cd"] = "Auto";
          ob["ld_jrnl_ln_ksn"] = manual_jrnl['data'][0]["jrnl_id"] + "-" + all_account_lines[i]["data"]["db_cd_ind"];
          ob["ld_jrnl_ln_desc"] = manual_jrnl['data'][0]['preparer_comment']//"ACCOUNT" + "-MANUAL JURNAL-" + manual_jrnl['data'][0]["jrnl_id"] + "-" + all_account_lines[i]["data"]["ar_cntr_ip_name"];
          ob["ld_src_cd"] = "ACCOUNT";
          ob["ld_tech_comp_cd"] = "ARE";
          ob["ld_jrnl_dtln_desc"] =
            "ACCOUNT" +
            "-MANUAL JURNAL-" +
            manual_jrnl['data'][0]["jrnl_id"]


          ob["ld_bus_func_cd"] = "MAUAL_JOURNAL2JV";
          ob["ld_unadj_acct_dt"] = this.current_date;
          ob["pmt_bnk_acct_id"] = all_account_lines[i]["data"]["proj_cd"]
          ob["ld_aff_cc_cd"] = all_account_lines[i]["data"]["proj_cd"]
          ob["ld_cc_cd"] = 0;
          ob["ld_jrnl_dtl_ln_ksn"] = "_" + i + "_" + i;
          data.push(ob);
        }
        if (all_account_lines[i]["type"] == "debit") {
          let ob:any = new Object();
          ob["ld_prj_cd"] = all_account_lines[i]['data']["proj_cd"];
          ob["ld_act_cd"] = all_account_lines[i]['data']["act_cd"];
          ob["ld_pd_cd"] = all_account_lines[i]['data']["prod_cd"];
          ob["ld_bugt_cd"] = all_account_lines[i]['data']["bud_cd"];
          ob["txn_amt"] =
            (-1 * all_account_lines[i]["data"]["txn_amt"]);
          ob["ar_actvty_tcd"] = "MANUAL_JRNL";
          ob["db_cd_ind"] = all_account_lines[i]["data"]["db_cd_ind"];
          ob["chart_of_account"] = all_account_lines[i]["data"]["chart_of_account"];
          ob["arr_id"] = manual_jrnl['data'][0]["jrnl_id"];
          ob["event_code"] = all_account_lines[i]["data"]["event_code"];
          ob["jrnl_dtl_ln_id"] = all_account_lines[i]["data"]["jrnl_dtl_ln_id"];
          ob["org_unit_cd"] = this.b_acct_id;
          ob["tgt_curr_cd"] = "INR";
          ob["jrnl_ln_id"] = all_account_lines[i]["data"]["jrnl_ln_id"];
          ob["fin_year"] = this.fin_year;
          ob["ev_cts"] = this.current_date;
          ob["ld_fm"] = month + 1;
          ob["acct_dt"] = all_account_lines[i]["data"]["acct_dt"];
          ob["jrnl_desc"] = " To " + this.ChartOfAccountObj[all_account_lines[i]["data"]["chart_of_account"]];
          ob["ledger_type"] = "ACT";
          ob["prep_id"] = all_account_lines[i]["data"]["prep_id"];
          ob["appr_id"] = this.erpUser.user_id;
          ob["ar_actvty_lcl_num"] = manual_jrnl['data'][0]['id']
          ob["ar_src_cd"] = "ACCOUNT";
          ob["ar_cntr_ip_id"] = all_account_lines[i]["data"]["ar_cntr_ip_id"];
          ob["ar_cntr_ip_name"] = all_account_lines[i]["data"]["ar_cntr_ip_name"];
          // ob["event_id"] = all_account_lines[i]["data"]["event_id"];
          ob["event_id"] = manual_jrnl['data'][0]['id'];
          ob["cp_bnk_acct_id"] = all_account_lines[i]["data"]["cp_bnk_acct_id"]
          ob["ld_jrnl_ref_num"] = "ACCOUNT-MANUAL_JOURNAL-" + manual_jrnl['data'][0]["jrnl_id"];
          ob["ld_jrnl_lfcycl_st_cd"] = "POSTED";
          ob["ld_jrnl_unpost_seq_num"] = 0;
          ob["ld_acct_per"] = 0;
          ob["ld_cat_cd"] = "FIN";
          ob["ld_jrnl_rvrsl_tcd"] = manual_jrnl['data'][0]['preparer_comment'];
          ob["ld_tgt_cur_tcd"] = "FN";
          ob["ld_jrnl_entry_cd"] = "Auto";
          ob["ld_jrnl_ln_ksn"] = manual_jrnl['data'][0]["jrnl_id"] + "-" + all_account_lines[i]["data"]["db_cd_ind"];
          ob["ld_jrnl_ln_desc"] = manual_jrnl['data'][0]['preparer_comment'];//"ACCOUNT" + "-MANUAL JURNAL-" + manual_jrnl['data'][0]["jrnl_id"] + "-" + all_account_lines[i]["data"]["ar_cntr_ip_name"];
          ob["ld_src_cd"] = "ACCOUNT";
          ob["ld_tech_comp_cd"] = "ARE";
          ob["ld_jrnl_dtln_desc"] = "ACCOUNT" + "-MANUAL JURNAL-" + manual_jrnl['data'][0]["jrnl_id"];
          ob["ld_bus_func_cd"] = "MAUAL_JOURNAL2JV";
          ob["ld_unadj_acct_dt"] = this.current_date;
          ob["pmt_bnk_acct_id"] = 0;
          ob["ld_aff_cc_cd"] = all_account_lines[i]["data"]["proj_cd"]
          ob["ld_cc_cd"] = all_account_lines[i]["data"]["proj_cd"]
          ob["ld_jrnl_dtl_ln_ksn"] = "_" + i + "_" + i;
          data.push(ob);
        }
      }
      let obj:any = new Object();
      obj["b_acct_id"] = this.b_acct_id;
      obj["data"] = data;
      obj['budget'] = bud_obj['data'];
      obj['actul_bud'] = bud_obj['actul_bud'];
      obj['fin_year'] = this.fin_year;
      obj["status"] = "POSTED";
      // this.spinner.hide()
      console.log(data);
      let resp = await this.ledgerService.postingJournal(obj);
      if (resp["error"] == false) {
        this.spinner.hide();
        // await this.getAllManualJournalInfo();
        // Swal.fire("SUCCESS", "Journal Posted Successfully!", "success");
        return true;
      } else {
        this.spinner.hide();
        Swal.fire("ERROR", "Error While Posting Manual Journal", "error");
        return false
      }
    } else {

      return false;
    }

  }


  /************************************Posting of manual journla END ***************************************************** */


  /************************************** Posting of Department Bill Document Start ************************************************************** */

  async processDepartmentBill(element:any) {
    this.spinner.show();
    let obj:any = Object.assign({}, {});

    obj['b_acct_id'] = this.b_acct_id
    obj['event_group_id'] = [element['doc_local_no']]
    obj['id'] = element.doc_local_no
    await this.FinYear();
    let event_group_data = await this.eventGroupService.geteventByID(JSON.stringify(obj));

    if (event_group_data['error'] == false) {
      let resp = await this.eventGroupService.geteventxref(JSON.stringify(obj));
      // let event_group_id = element['id'];
      let eventdata = []
      eventdata = resp['data'];
      let processed_data = await this.ruleProcessingNewService.startProcessing(eventdata);
      let bud_obj = await this.budgetEffectService.getBudgetObj(eventdata, this.b_acct_id, event_group_data.data[0].total_amt);
      if (bud_obj['error'] === true) {
        this.spinner.hide();
        Swal.fire("Error", bud_obj['data'], 'error');
        return false;
      }
      if (processed_data['error'] == true) {
        this.spinner.hide();
        Swal.fire("Error", processed_data['data'], 'error');
        return false;
      }
      if (processed_data['data'].length > 0) {
        let obj1 = Object.assign({}, element);
        obj1['b_acct_id'] = this.b_acct_id;
        // if (this.ListObj['module_cd'] === 'OPERATION') {
        //   obj1['status'] = 'APPROVED';
        // } else {
        //   obj1['status'] = 'PROCESSED';
        // }
        obj1['status'] = 'PROCESSED';
        obj1['update_user_id'] = this.erpUser.user_id;
        obj1['jrnl'] = processed_data['data'];
        obj1['budget'] = bud_obj['data'];
        obj1['actul_bud'] = bud_obj['actul_bud'];
        obj1['fin_year'] = this.fin_year;
        let resp = await this.eventGroupService.insertProcessedData(obj1);
        if (resp['error'] == false) {
          this.spinner.hide();
          // if (this.ListObj['module_cd'] === 'OPERATION') {
          //   // this.ListObj['status'] = "UNDERAPPROVAL"
          //   this.ListObj['jrnl_id'] = resp['data']['jrnl_id']
          //   await this.submit();

          // }
          //  else {
          // await this.submit();
          // Swal.fire("Success", "Processed Successfully!", 'success');
          // }
          // this.ListObj['jrnl_id'] = resp['data']['jrnl_id']
          // await this.submit();
          return true;
        } else {

          this.spinner.hide();
          Swal.fire("Error", "...Error while Processed  Bill Insert!", 'error');
          return false;
        }
      } else {
        this.spinner.hide();
        Swal.fire("Error", "...Some Events does not have rule  !", 'error');
        return false
      }
    } else {

      this.spinner.hide();
      Swal.fire("Error", "...Some Error Occured While Processing", 'error');
      return false
    }
  }

  /************************************** Posting of Department Bill Document Start ************************************************************** */




  /**************************************Posting of BP Start ************************************************************** */

  // async insert_jrnl(bp_ids) {

  //   let obj = {};
  //   obj['b_acct_id'] = this.erpUser.b_acct_id
  //   obj['bp_id'] = bp_ids
  //   let resp = await this.BPS.getList(JSON.stringify(obj));
  //   if (resp['error'] == false) {
  //     let bank_paymnet_data: any = []
  //     bank_paymnet_data = resp['data']
  //     let arr1 = []
  //     bank_paymnet_data.map(async (x, i) => {
  //       let event = JSON.parse(x['data'])
  //       let ob_db = new Object();
  //       ob_db = {
  //         "arr_id": event['arr_id'],
  //         "acct_dt": event['bp_date'],
  //         "appr_id": this.erpUser.user_id,
  //         "ar_src_cd": "ACCOUNT",
  //         "ar_num_in_src": null,
  //         "ar_actvty_tcd": "BP",
  //         // "ar_actvty_lcl_num": event_id + i,
  //         "ar_actvty_lcl_num": event['ev_grp_lcl_unq_num_in_src'],
  //         "ar_instr_cd": event['ar_instr_cd'],
  //         "ar_cntr_ip_id": event['party_id'],
  //         "ar_cntr_ip_name": event['party_leagal_name'],
  //         "create_timestamp": this.systemDate,
  //         "chart_of_account": event['chart_of_account'],
  //         "cp_bnk_acct_id": 0,
  //         "db_cd_ind": "DB",
  //         "event_code": event['event_code'],
  //         "event_id": event.id,
  //         "ev_cts": event['bp_date'],
  //         "fin_year": this.fin_year,
  //         "jrnl_dtl_ln_id": "1",
  //         "jrnl_ln_id": 1,
  //         "jrnl_id": event['jrnl_id'],
  //         "jrnl_desc": 'To ' + this.ChartOfAccountObj[x['bank_chart_of_account']],
  //         "ledger_type": "ACT",
  //         "ld_jrnl_ref_num": event['ld_jrnl_ref_num'],
  //         // "ld_jrnl_lfcycl_st_cd": "PROCESSED",
  //         "ld_jrnl_lfcycl_st_cd": "POSTED",
  //         "ld_jrnl_unpost_seq_num": 0,
  //         "ld_fm": 11,
  //         "ld_acct_per": 328,
  //         "ld_cat_cd": "FIN",
  //         "ld_jrnl_entry_cd": "Auto",
  //         "ld_tgt_cur_tcd": "FN",
  //         "ld_jrnl_rvrsl_tcd": event['ld_jrnl_rvrsl_tcd'],
  //         "ld_jrnl_rvrsl_dt": null,
  //         "ld_parent_jrnl_id": null,
  //         "ld_jrnl_ln_ksn": event['jrnl_id'] + "-DB",
  //         "ld_jrnl_ln_desc": event['jrnl_desc'],
  //         "ld_bk_cd": null,
  //         "ld_src_cd": "ACCOUNT",
  //         "ld_pd_cd": event['ld_pd_cd'],
  //         "ld_prj_cd": event['ld_prj_cd'],
  //         "ld_jrnl_dtl_ln_ksn": "_" + 1 + "_0",
  //         "ld_tech_comp_cd": "ARE",
  //         "ld_jrnl_dtln_desc": event['jrnl_desc'],
  //         "ld_bus_func_cd": "JV2BP",
  //         "ld_unadj_acct_dt": this.systemDate,
  //         "org_unit_cd": this.b_acct_id,
  //         "proc_dt": null,
  //         "prep_id": this.erpUser.user_id,
  //         "pmt_bnk_acct_id": 0,
  //         "tgt_curr_cd": "INR",
  //         "txn_amt": (-1) * event['txn_amt'],
  //         "ld_cc_cd": event['ld_cc_cd'],
  //         "ld_aff_cc_cd": "0",
  //         "ld_bugt_cd": event['ld_bugt_cd']
  //       }

  //       let ob_cr = new Object();
  //       ob_cr = {
  //         "arr_id": event['arr_id'],
  //         "acct_dt": event['bp_date'],
  //         "appr_id": this.erpUser.user_id,
  //         "ar_src_cd": "ACCOUNT",
  //         "ar_num_in_src": null,
  //         "ar_actvty_tcd": "BP",
  //         // "ar_actvty_lcl_num": event_id + i,
  //         "ar_actvty_lcl_num": event['ev_grp_lcl_unq_num_in_src'],
  //         "ar_instr_cd": event['ar_instr_cd'],
  //         "ar_cntr_ip_id": event['party_id'],
  //         "ar_cntr_ip_name": event['party_leagal_name'],
  //         "create_timestamp": this.systemDate,
  //         "chart_of_account": event['bank_chart_of_account'],
  //         // "cp_bnk_acct_id": event['org_bank_acct_no'],
  //         "cp_bnk_acct_id": event['relation'],
  //         "db_cd_ind": "CR",
  //         "event_code": event['event_code'],
  //         "event_id": event ,
  //         "ev_cts": event['bp_date'],
  //         "fin_year": this.fin_year,
  //         "jrnl_dtl_ln_id": "1",
  //         "jrnl_ln_id": 1,
  //         "jrnl_id": event['jrnl_id'],
  //         "jrnl_desc": 'By ' + this.ChartOfAccountObj[event['bank_chart_of_account']],
  //         "ledger_type": "ACT",
  //         "ld_jrnl_ref_num": event['ld_jrnl_ref_num'],
  //         "ld_jrnl_lfcycl_st_cd": "POSTED",
  //         "ld_jrnl_unpost_seq_num": 0,
  //         "ld_fm": 11,
  //         "ld_acct_per": 328,
  //         "ld_cat_cd": "FIN",
  //         "ld_jrnl_entry_cd": "Auto",
  //         "ld_tgt_cur_tcd": "FN",
  //         "ld_jrnl_rvrsl_tcd": event['ld_jrnl_rvrsl_tcd'],
  //         "ld_jrnl_rvrsl_dt": null,
  //         "ld_parent_jrnl_id": null,
  //         "ld_jrnl_ln_ksn": event['jrnl_id'] + "-CR",
  //         "ld_jrnl_ln_desc": event['jrnl_desc'],
  //         "ld_bk_cd": null,
  //         "ld_src_cd": "ACCOUNT",
  //         "ld_pd_cd": event['ld_pd_cd'],
  //         "ld_prj_cd": event['ld_prj_cd'],
  //         "ld_jrnl_dtl_ln_ksn": "_" + 1 + "_0",
  //         "ld_tech_comp_cd": "ARE",
  //         "ld_jrnl_dtln_desc": event['jrnl_desc'],
  //         "ld_bus_func_cd": "JV2BP",
  //         "ld_unadj_acct_dt": this.systemDate,
  //         "org_unit_cd": this.b_acct_id,
  //         "proc_dt": null,
  //         "prep_id": this.erpUser.user_id,
  //         "pmt_bnk_acct_id": 0,
  //         "tgt_curr_cd": "INR",
  //         "txn_amt": event['txn_amt'],
  //         "ld_cc_cd": event['ld_cc_cd'],
  //         "ld_aff_cc_cd": "0",
  //         "ld_bugt_cd": event['ld_bugt_cd']
  //       }
  //       arr1.push(ob_cr, ob_db)
  //     })

  //     let obj1 = {}
  //     obj1['b_acct_id'] = this.b_acct_id;
  //     obj1['jrnl'] = arr1;
  //     let resp2 = await this.BPS.insertProcessedbp(obj1);
  //     if (resp2['error'] == false) {
  //       this.spinner.hide();
  //       Swal.fire("Success", "Bank Payment Processed Successfully!", 'success');

  //     } else {
  //       this.spinner.hide();
  //       Swal.fire("Error", "...Error while Processing Bank Payment  !", 'error');

  //     }
  //   }
  // }


  /**************************************Posting of BP End ************************************************************** */





}
